import { Check, X } from "lucide-react";
import { AppButton } from "@libs/zapi-ui/custom";
import { useTranslation } from "react-i18next";

type TProps = {
  name: string;
  isThisDeleting: boolean;
  onConfirmDelete: () => void;
  onCancelDelete: () => void;
};

export function DimensionConfirmDelete(props: TProps) {
  const { name, isThisDeleting, onConfirmDelete, onCancelDelete } = props;
  const { t } = useTranslation("projects");

  return (
    <>
      <div className="flex min-w-0 flex-1 flex-col gap-1 pt-1">
        <p className="truncate text-[14px] font-medium leading-[22px] text-[#3f3f46]" title={name}>
          {t("dimensions.confirmDelete", { name })}
        </p>
        <p className="text-[14px] leading-[22px] text-[#71717a]">{t("dimensions.confirmDeleteBody")}</p>
      </div>
      <div className="flex items-center gap-1">
        <AppButton
          size="icon"
          appearance="contained"
          color="red400"
          onClick={onConfirmDelete}
          disabled={isThisDeleting}
          isLoading={isThisDeleting}
          aria-label={t("dimensions.confirmDeleteAction")}
        >
          <Check className="h-4 w-4" strokeWidth={2.5} />
        </AppButton>
        <AppButton
          size="icon"
          appearance="text"
          color="zinc950"
          onClick={onCancelDelete}
          disabled={isThisDeleting}
          aria-label={t("dimensions.cancelDeleteAction")}
        >
          <X className="h-4 w-4" />
        </AppButton>
      </div>
    </>
  );
}
